import { render } from "./AttendanceModal.vue?vue&type=template&id=fb974882"
import script from "./AttendanceModal.vue?vue&type=script&lang=js"
export * from "./AttendanceModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__